import { dropBoolean } from 'utils/drops';

const getUnidadeMedidaFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'sigla', label: 'Sigla' },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getUnidadeMedidaFilterFields;
